module.exports = __webpack_public_path__ + "static/img/img1.1cb9b9b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/course/img1.jpg
// module id = hLpG
// module chunks = 1